import moment from 'moment'

var field = {
  width: '100px',
  display: 'inline-block',
  paddingRight: '6px',
  textAlign: 'left'
}

let DEFAULT_FORM_VALUES = {
  unitGroupID: 0,
  unitGroupUnitID: 0,
  unitID: 0,
  name: ''
}

export const data = () => ({
  audienceTypeList: [],
  fullList: [],
  data: [],
  dataCopy: [],
  name: '',
  recipientsSelected: [],
  ownerIdsSelected: [],
  isFiltering: false,
  query: null,
  selected: null,
  isReadOnly: false,
  formComplete: false,
  formData: {
    address: '',
    ...DEFAULT_FORM_VALUES
  },
  loading: false,
  isDebug: true,
  toggle: false,
  completeToggle: false,
  openOnFocus: true,
  mailingTypeList: null,
  showPreview: false,
  showAttachments: false,
  showSelectedAudience: false,
  showHomeownerModal: false,
  showUnitGroupUnitModal: false,
  filterBy: '',
  filterOwnerBy: '',
  filterList: [],
  unitList: [],
  unitGroupList: [],
  unitGroupListCopy: [],
  unitGroupUnitList: [],
  checkRowsOne: [],
  checkedRows: [],
  action: '',
  checkboxPosition: 'left',

  formatDateFn: function(value) {
    return value && value != undefined
      ? moment(value.toString(), 'YYYY/MM/DD HH:mm:ss')
          .format('MM-DD-YYYY')
          .toString()
      : ''
  },
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    },
    amountField: Object.assign({}, field, {
      width: '125px'
    })
  }
})
